import type {
  AddFieldPlacementTarget,
  AuthoredEntityOrSingleSchema
} from '@cli-types/core-engine/add-field.js'
import { collectSchemaNestedTargets } from './collect-schema-nested-targets.js'
import { ensureSchemaFields } from './ensure-schema-fields.js'
import { ensureSlotFields } from './ensure-slot-fields.js'
import { readSchemaSlotFields } from './read-schema-slot-fields.js'

export function buildSchemaPlacementTargets(
  schema: AuthoredEntityOrSingleSchema
): AddFieldPlacementTarget[] {
  const targets: AddFieldPlacementTarget[] = []

  if (schema.slot) {
    targets.push({
      id: 'root:slot:main',
      label: 'top-level slot.main.fields',
      scope: 'schema',
      getFields: () => ensureSlotFields(schema, 'main')
    })
    targets.push({
      id: 'root:slot:sidebar',
      label: 'top-level slot.sidebar.fields',
      scope: 'schema',
      getFields: () => ensureSlotFields(schema, 'sidebar')
    })
    collectSchemaNestedTargets(readSchemaSlotFields(schema.slot), 'slot', 'schema', targets)
    return targets
  }

  targets.push({
    id: 'root:fields',
    label: 'top-level fields',
    scope: 'schema',
    getFields: () => ensureSchemaFields(schema)
  })
  collectSchemaNestedTargets(schema.fields ?? [], 'fields', 'schema', targets)
  return targets
}
